import { axiosInstance } from "../index";
import config from "../config";
import { getHeaders } from './helpers';

const { apiUrl } = config;


// TODO: Requires elaboration of what's the difference between both functions 

export const getNotifications = async (conversationID) => {
    if(!conversationID){
        return [];
    }                             
    const result = await axiosInstance
        .get(
            `${apiUrl}/pull-notification?conversationId=${conversationID}`,
            { headers: getHeaders() }
        );
    
    return result.data.hmrcResponse.data    ?? [] 
}

export const getAllNotifications = async (functionalReferenceID) => {
    if (!functionalReferenceID){
        return [];
    }
    const result = await axiosInstance
        .get(
            `${apiUrl}/crudnotifications/go?functionalReferenceId=${functionalReferenceID}`,
            { headers: getHeaders() }
        );
                            
    return result.data.items ?? []
}
